import React, { useState } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import Button from "../../components/Button/Button";
import modals from "../../components/ModalAdditionResult/modals"; //TO DO REFACTOR WE DON'T NEED THIS
import FormGetItemByKey from "../../components/FormGetItemByKey/FormGetItemByKey";
import HotSpotForm from "../../containers/HotSpotForm/HotSpotForm";
import { addSpot } from "../../services/api";
import TYPE from "../../constants/searchType";
import {
  setIsLoading,
  setSpotToEdit,
  getSpotByTypeKey,
} from "../../reduxSetup/action";
import styles from "./HotSpotEditor.module.scss";
import GreenSpotForm from "../../containers/GreenSpotForm/GreenSpotForm";

const HotSpotsEditor = ({
  setIsLoading,
  setSpotToEdit,
  spotToEdit,
  getSpotByTypeKey,
  user,
}) => {
  const {lng}=useParams()
  const [spotKey, setSpotKey] = useState("");
  const [type, setType] = useState("hotSpot");
  const [stepStatus, setStepStatus] = useState(false)
  const clearAll = ({
    setHotSpotFields,
    setGreenSpotFields,
    setValidationError,
    setName,
    setCountries,
    setAddress,
    setPhotos,
    setVideos,
    setRelatedOrganizations,
    setLinks,
    setProblem,
    setSolutions,
    setTimeline,
    setFaq,
    setTitleSeo,
    setDescriptionSeo
  }) => {
    const logoHTML = document.getElementById("addLogo");
    setHotSpotFields([]);
    setGreenSpotFields([])
    setValidationError([]);
    setName("");
    setAddress("");
    setCountries([])
    setSpotToEdit(false);
    setSpotKey("");
    setTitleSeo("");
    setDescriptionSeo("");
    setPhotos && setPhotos([]);
    setVideos && setVideos([{}]);
    setProblem && setProblem([{}]);
    setSolutions && setSolutions([{}])
    setTimeline && setTimeline([{}]);
    setFaq && setFaq([{}]);
    setRelatedOrganizations && setRelatedOrganizations([{}]);
    setLinks && setLinks([{}]);
    logoHTML && (logoHTML.value = "");
  };
  const handleSubmit = ({
    toggleModal,
    name,
    countries,
    address,
    hotSpotFields,
    greenSpotFields,
    problem,
    solutions,
    timeline,
    faq,
    links,
    photos,
    videos,
    relatedOrganizations,
    titleSeo,
    descriptionSeo,
    key,
    originalId,
    originalType,
    setValidationError,
    setHotSpotFields,
    setGreenSpotFields,
    setName,
    setCountries,
    setAddress,
    setPhotos,
    setVideos,
    setProblem,
    setSolutions,
    setTimeline,
    setFaq,
    setRelatedOrganizations,
    setLinks,
    setTitleSeo,
    setDescriptionSeo
  }) => {

    setIsLoading(true);
    addSpot({
      name,
      countries: countries,
      address,
      fields: type==='hotSpot'?hotSpotFields:greenSpotFields,
      status: "onreview",
      author: user.email,
      photos,
      videos,
      problem,
      solutions,
      timeline,
      faq,
      relatedOrganizations,
      links,
      type,
      titleSeo,
      descriptionSeo,
      key,
      originalId: originalId ? String(originalId) : undefined,
      originalType,
    })
      .then((response) => {
        if (response?.status === 200) {
          toggleModal(modals.organization);
          clearAll({
            setHotSpotFields,
            setGreenSpotFields,
            setValidationError,
            setCountries,
            setName,
            setAddress,
            setProblem,
            setSolutions,
            setTimeline,
            setFaq,
            setPhotos,
            setRelatedOrganizations,
            setLinks,
            setVideos,
            setTitleSeo,
            setDescriptionSeo
          });
          setStepStatus(true)
        }

        if (!response) {
          toggleModal(modals.wrongAddress);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className={styles.addNewContainer}>
      <h1 className={styles.title}>Create new or edit a spot</h1>
      <div className={styles.formContainer}>
        <div className={styles.buttonsContainer}>
          {TYPE.filter(
            (item) => item.value == "hotSpot" || item.value == "greenSpot"
          ).map((item) => (
            <Button
              key={item.value}
              className={cx(styles.typeButton, {
                [styles.activeButton]: type === item.value,
              })}
              onClick={() => setType(item.value)}
            >
              {item.label}
            </Button>
          ))}
        </div>

        <FormGetItemByKey
          type={type}
          itemKey={spotKey}
          setItemKey={setSpotKey}
          getItemToEdit={getSpotByTypeKey}
        />
      </div>
      {
        type==='hotSpot'?
        <HotSpotForm
          spotToEdit={spotToEdit}
          handleSubmit={handleSubmit}
          clearAll={clearAll}
          isSpotEditor={true}
          lng={lng}
          stepStatus={stepStatus}
          type={type}
        />:
        <GreenSpotForm spotToEdit={spotToEdit}
        handleSubmit={handleSubmit}
        clearAll={clearAll}
        isSpotEditor={true}
        lng={lng}
        stepStatus={stepStatus}
        type={type} />
      }
    </div>
  );
};

HotSpotsEditor.propTypes = {
  match: PropTypes.object,
  setIsLoading: PropTypes.func,
  setSpotToEdit: PropTypes.func,
  spotToEdit: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  getSpotByTypeKey: PropTypes.func,
  user: PropTypes.object,
};
HotSpotsEditor.dafaultProps = {
  setIsLoading: () => { },
  email: "",
};

const mapStateToProps = ({ companies, user }) => {
  const { spotToEdit } = companies;
  return {
    spotToEdit,
    user,
  };
};

const mapDispatchToProps = {
  setIsLoading,
  setSpotToEdit,
  getSpotByTypeKey,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HotSpotsEditor);
